import { render, staticRenderFns } from "./courseDetailLoader.vue?vue&type=template&id=cd2d6f92&"
import script from "./courseDetailLoader.vue?vue&type=script&lang=js&"
export * from "./courseDetailLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports